import { CurrencyCode } from '@easy-expense/data-schema-v2';
import { getTranslation, useIntlStore } from '@easy-expense/intl-client';
import { currencies as data } from '@easy-expense/utils-shared/src/CurrencyConstants';
import _ from 'lodash';
import React from 'react';

import { AutoCompleteValue } from '../../Shared/Dropdown/AutoCompleteTypes';
import { SearchDropdown } from '../../Shared/Dropdown/SearchDropDown.component';

export const CurrencyTypeSelector: React.FC<
  React.PropsWithChildren<{
    onChange: (value: { currency: CurrencyCode | null; icon: string } | null) => void;
    originalCurrency?: CurrencyCode | null;
  }>
> = ({ onChange, originalCurrency }) => {
  const intlStore = useIntlStore();

  const currency = originalCurrency ?? intlStore.currency;

  const currencies = React.useMemo(() => {
    const currencies = data;

    const formattedCurrencies = Object.entries(currencies).map(([key, value]) => ({
      key,
      value: {
        name: value.code,
        icon: value.symbol_native.slice(0, 2),
      },
    }));

    const prioritizedCurrencies = ['USD', 'CAD', 'EUR'];

    const sortedCurrencies = [
      ...formattedCurrencies.filter((currency) => prioritizedCurrencies.includes(currency.key)),
      ...formattedCurrencies.filter((currency) => !prioritizedCurrencies.includes(currency.key)),
    ];

    return sortedCurrencies;
  }, []);

  return (
    <SearchDropdown
      autoCompleteValues={currencies}
      header={getTranslation('Currency')}
      placeholder={currency ?? 'USD'}
      onSelect={(value: AutoCompleteValue | null) => {
        if (value?.key === intlStore.currency) {
          onChange({ currency: null, icon: '$' });
          return;
        }

        if (value) {
          onChange({ currency: value.key as CurrencyCode, icon: value.value.icon ?? '$' });
        }
      }}
      selectedKey={originalCurrency ?? currency}
      error={false}
      iconicIcon={'cash-outline'}
      clearOnSelect={true}
    />
  );
};
